import React, {useEffect, useState} from 'react';
import {twMerge} from 'tailwind-merge';
import LinearText from '../linear-text/linear-text';
import LinearImage from '../linear-image/linear-image';

interface Partners {
    name: string;
    src: string;
    width: number;
    height: number;
}

interface ConcertPartnerProps {
    partners: Partners[];
    containerClassName?: string;
    contentContainerClassName?: string;
}

const ConcertPartners: React.FC<ConcertPartnerProps> = ({partners, containerClassName, contentContainerClassName}) => {
    const [point, setPoint] = useState<number>(48);

    useEffect(() => {
        const updatePoint = () => {
            const deviceWidth = window.innerWidth
            if(deviceWidth < 1233) {
                setPoint(72)
            } else if(deviceWidth < 1034) {
                setPoint(70)
            } else if(deviceWidth < 1438) {
                setPoint(66)
            } else if(deviceWidth < 1536) {
                setPoint(63)
            } else if(deviceWidth < 1673) {
                setPoint(60)
            } else if(deviceWidth < 1878) {
                setPoint(56)
            } else if (deviceWidth < 2001 ) {
                setPoint(56)
            } else if (deviceWidth > 2001) {
                setPoint(56)
            }
        };

        updatePoint();
        window.addEventListener('resize', updatePoint);
        return () => window.removeEventListener('resize', updatePoint);
    }, []);

    const containerStyle = twMerge(
        `h-full w-full rounded-2xl flex flex-col justify-start items-center`,
        containerClassName,
    );
    const contentContainerStyle = twMerge(
        `flex flex-wrap justify-center items-center gap-[14px]`,
        contentContainerClassName,
    );
    return (
        <div
            className="p-2 rounded-2xl w-full max-w-[1508px]"
            style={{
                background:
                    'linear-gradient(290.93deg, #DABA03 18.72%, #FFF04D 37.08%, #FFFDBD 43.79%, #CEAF00 57.39%, #FFFDBD 66.64%, #FFE659 77.01%)',
            }}>
            <div
                className={containerStyle}
                style={{
                    background: 'linear-gradient(103.28deg, #FFFEE6 1.06%, #F6E989 95.93%)',
                }}>
                <div className={contentContainerStyle}>
                    {partners.slice(0, point).map(item => (
                        <LinearImage
                            className={'w-[150px] h-[70px] rounded-[14px]'}
                            key={item.name}
                            src={item.src}
                            width={item.width}
                            height={item.height}
                            alt={item.name}
                            imageClassName="rounded-[14px] object-contain"
                            imageContainerClassName="rounded-[14px]"
                        />
                    ))}
                    <div
                        className={contentContainerStyle}
                        style={{
                            marginLeft: '328px',
                        }}>
                        {partners.slice(point, partners.length).map(item => (
                            <LinearImage
                                className={'w-[150px] h-[70px] rounded-[14px]'}
                                key={item.name}
                                src={item.src}
                                width={item.width}
                                height={item.height}
                                alt={item.name}
                                imageClassName="rounded-[14px] object-contain"
                                imageContainerClassName="rounded-[14px] md:!p-2 p-1"
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConcertPartners;
